<template>
    <div class="filled-content help-page">
        <v-toolbar app flat dark tabs color="primary">
            <v-btn icon @click="gotoOverview()">
                <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title>Help &amp; Support</v-toolbar-title>
            <v-btn icon></v-btn>
            <template v-slot:extension>
                <v-tabs centered grow slot="extension" color="primary" v-model="tab">
                    <v-tab href="#tab-1">FAQ</v-tab>
                    <v-tab href="#tab-2">Tutorials</v-tab>
                    <v-tab href="#tab-3">Support</v-tab>
                </v-tabs>
            </template>
        </v-toolbar>
        <v-content>
            <v-tabs-items v-model="tab">
                <v-tab-item :value="'tab-1'">
                    <faq></faq>
                </v-tab-item>
                <v-tab-item :value="'tab-2'">
                    <tutorials></tutorials>
                </v-tab-item>
                <v-tab-item :value="'tab-3'">
                    <v-container>
                        <p>
                            Als je het antwoord op je vraag niet kunt vinden in onze FAQ's of Tutorials,
                            is onze klantenservice 24/7 bereikbaar op <b>085 - 06 06 140</b>.
                            Je kunt ons ook een mail sturen naar
                            <a href="mailto:klantenservice@e-finder.com" target="_blank">klantenservice@e-finder.com</a>
                            of het formulier hieronder invullen en op Versturen klikken.
                        </p>
                        <form class="text-xs-center" @submit.prevent="sendSupportMessage()">
                            <validation-observer ref="validationObserver">
                                <validation-provider name="Message" rules="required" v-slot="{ errors }" slim>
                                    <v-text-field
                                            v-model="title"
                                            type="text"
                                            :error-messages="errors[0]"
                                            label="Titel"
                                            :counter="20"
                                            :maxlength="20"
                                            required
                                            box
                                            class="mb-3"
                                    ></v-text-field>
                                </validation-provider>
                                <validation-provider name="Message" rules="required" v-slot="{ errors }" slim>
                                    <v-textarea
                                            name="Message"
                                            :error-messages="errors[0]"
                                            type="text"
                                            v-model="message"
                                            :counter="600"
                                            :maxlength="600"
                                            auto-grow
                                            required
                                            label="Bericht"
                                            box
                                    ></v-textarea>
                                </validation-provider>
                            </validation-observer>
                            <v-btn
                                    :loading="sending"
                                    block large depressed
                                    color="primary"
                                    class="white--text mb-2"
                                    type="submit"
                            >
                                Versturen
                            </v-btn>
                        </form>
                    </v-container>
                </v-tab-item>
            </v-tabs-items>
        </v-content>
    </div>
</template>

<script>
    import {ValidationObserver, ValidationProvider} from 'vee-validate';
    import UserService from '../../services/UserService';
    import Faq from './tabs/Faq.vue';
    import Tutorials from './tabs/Tutorials.vue';

    export default {
    components: { ValidationProvider, ValidationObserver, Faq, Tutorials },
  data() {
    return {
        tab: null,
        sending: false,
        title: '',
        message: ''
    }
  },
  methods: {
    gotoOverview() {
      this.$router.go(-1);
    },
      async sendSupportMessage() {
          try {
              this.sending = true;
              await UserService.sendSupportMessage({
                  title: this.title,
                  message: this.message,
              });
              this.sending = false;
          }catch(e){
              this.error = e.response;
              this.sending = false;
          }
      }
  },
};
</script>

<style lang="stylus">

	.help-page
		p
			font-size: 16px

		.v-expansion-panel
			box-shadow: none
			border-top: solid 1px #ddd
			border-bottom: solid 1px #ddd

		.image-container
			display: flex
			flex-direction: column
			align-items: center
			margin: 32px 16px

		img
			width: 100%
			height: auto
</style>
